import React from 'react';
import { Link } from 'react-router-dom';
import companyConfig from '../config/companyConfig';

function ServicesDetailed() {

  // Get services from config - now changes in config will reflect here!
  const services = companyConfig.services.map(service => ({
    id: service.id,
    icon: service.icon,
    title: service.title,
    description: service.fullDescription,
    link: `/services/${service.slug}`
  }));

  return (
    <div className="services-detailed-page">
      {/* Hero Banner */}
      <section className="services-hero-banner">
        <div className="services-hero-content">
          <h1 className="services-hero-heading">Our Services</h1>
          <p className="services-hero-subtext">
            Choose the method that works best for you. Our team is standing by to help.
          </p>
        </div>
      </section>

      <div className="services-detailed-container">
        {/* All Services Grid */}
        <section className="additional-services-section">
          <h2 className="additional-services-heading">All Services</h2>
          <div className="services-cards-grid">
            {services.map((service) => (
              <Link to={service.link} key={service.id} className="service-detail-card">
                <div className="service-card-accent-bar"></div>
                <div className="service-card-icon-wrapper">
                  <i className={`fas ${service.icon}`}></i>
                </div>
                <h3 className="service-card-title">{service.title}</h3>
                <p className="service-card-description">{service.description}</p>
                <div className="service-card-actions">
                  <button className="service-card-btn-primary">
                    Consult Now
                  </button>
                </div>
              </Link>
            ))}
          </div>
        </section>
      </div>
    </div>
  );
}

export default ServicesDetailed;
